import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';

/**
 *  Generates a checkbox element
 *
 */
const Checkbox = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    checked = false,
    label,
    labelClassName,
    onChange = () => {},
    secondaryLabel,
    ...rest
  } = _ref;
  const [isChecked, setIsChecked] = useState(checked);
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);
  const handleChange = event => {
    event.persist();
    setIsChecked(state => !state);
    onChange(event);
  };
  const secondLabel = secondaryLabel && /*#__PURE__*/_jsx("div", {
    className: "text-normal"
  }, void 0, secondaryLabel);
  const labelClassNames = clsx({
    checkbox: true
  }, labelClassName);
  return /*#__PURE__*/_jsx("label", {
    className: labelClassNames,
    "data-cmp": "checkbox"
  }, void 0, /*#__PURE__*/React.createElement("input", Object.assign({
    key: label,
    ref: input => ref && ref.current.push(input),
    type: "checkbox",
    onChange: handleChange,
    checked: isChecked
  }, rest)), label && /*#__PURE__*/_jsx("div", {
    className: "input-label"
  }, void 0, label), secondLabel && /*#__PURE__*/_jsx("div", {
    className: "input-secondary-label"
  }, void 0, secondLabel));
});
export default Checkbox;